
import { defineComponent, ref } from "vue";
import { useApi } from "~/composable/useApi";
import ProofreadersRepository from "~/repositories/ProofreadersRepository";
import ModalAiProofreaderLogin from "~/components/StaticPages/ModalAiProofreaderLogin.vue";
import ModalAiProofreader from "~/components/StaticPages/ModalAiProofreader.vue";

type Props = {
  isUserLoggedIn: boolean;
}

type Result = {
  userContent: string;
  fixedUserContent: string;
}

export default defineComponent({
  name: "OpenAIProofreader",
  components: {
    ModalAiProofreaderLogin,
    ModalAiProofreader
  },
  props: {
    isUserLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props: Props) {
    const userContent = ref("");
    const result = ref<Result>({ userContent: "", fixedUserContent: "まだチェックするものがありません。" });
    const isShowConfirmationModal = ref(false);
    const createNewProofreader = async () => {
      closeConfirmationModal();
      await newProofreaderDemoApi();
    };

    const isShowLoginModal = !props.isUserLoggedIn;

    const {
      handleApi: newProofreaderDemoApi,
      loading: loading,
      errors: errors
    } = useApi(async () => {
      const repository = new ProofreadersRepository();
      result.value = await repository.create({ userContent: userContent.value });
    });

    const openConfirmationModal = () => {
      isShowConfirmationModal.value = true;
    };

    const closeConfirmationModal = () => {
      isShowConfirmationModal.value = false;
    };

    const copyText = () => {
      navigator.clipboard.writeText(result.value.fixedUserContent);
    };

    const resetForm = () => {
      userContent.value = "";
      result.value = { userContent: "", fixedUserContent: "まだチェックするものがありません。" };
    };

    return {
      isShowLoginModal,
      isShowConfirmationModal,
      createNewProofreader,
      openConfirmationModal,
      closeConfirmationModal,
      copyText,
      resetForm,
      userContent,
      result,
      loading,
      errors
    };
  }
});
